import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram } from "@fortawesome/free-brands-svg-icons";
import {
  faHouse,
  faNewspaper,
  faPaperPlane,
  faImages,
  faCircleInfo,
  faPeopleGroup,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import AFT_logo_trimmed from "../../assets/other/AFT_logo_trimmed.png";
import { useLanguage } from "../../i18n/LanguageContext";
import LanguageSwitch from "../../i18n/LanguageSwitch";
import { nav } from "../../i18n/content";

const NavbarElem = () => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const { t } = useLanguage();

  const handleOffcanvasClose = () => {
    setShowOffcanvas(false);
  };

  return (
    <Navbar expand={"lg"} className="bg-body-tertiary custom-navbar navbar-test-theme">
      <Container fluid className="navbar-container">
        <Navbar.Brand as={Link} to="/" className="logo">
          <img src={AFT_logo_trimmed} alt="AFT Logo" />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls={`offcanvasNavbar-expand-lg`}
          onClick={() => setShowOffcanvas(!showOffcanvas)}
        />

        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-lg`}
          aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
          placement="end"
          show={showOffcanvas}
          onHide={handleOffcanvasClose}
          className="test-offcanvas"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-lg`}>
              {t(nav.menu)}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="navv flex-grow-1 pe-3">
              <ul>
                <li>
                  <Link to="/" onClick={handleOffcanvasClose}>
                    <FontAwesomeIcon icon={faHouse} />
                    <p>{t(nav.main)}</p>
                  </Link>
                </li>
                <li onClick={handleOffcanvasClose}>
                  <Link to="/blog">
                    <FontAwesomeIcon icon={faNewspaper} />
                    <p>{t(nav.blog)}</p>
                  </Link>
                </li>
                <li onClick={handleOffcanvasClose}>
                  <Link to="/submission">
                    <FontAwesomeIcon icon={faPaperPlane} />
                    <p>{t(nav.submission)}</p>
                  </Link>
                </li>
                <li onClick={handleOffcanvasClose}>
                  <Link to="/gallery">
                    <FontAwesomeIcon icon={faImages} />
                    <p>{t(nav.gallery)}</p>
                  </Link>
                </li>
                <li onClick={handleOffcanvasClose}>
                  <Link to="/about_us">
                    <FontAwesomeIcon icon={faCircleInfo} />
                    <p>{t(nav.about)}</p>
                  </Link>
                </li>
                <li onClick={handleOffcanvasClose}>
                  <Link to="/our_team">
                    <FontAwesomeIcon icon={faPeopleGroup} />
                    <p>{t(nav.team)}</p>
                  </Link>
                </li>
                <li onClick={handleOffcanvasClose}>
                  <Link to="/contact">
                    <FontAwesomeIcon icon={faPhone} />
                    <p>{t(nav.contact)}</p>
                  </Link>
                </li>
              </ul>
              <div className="navbar-social-logo">
                <li>
                  <Link to="https://www.facebook.com/adjarianfilmtales">
                    <FontAwesomeIcon icon={faFacebookF} />
                  </Link>
                </li>
                <li>
                  <Link to="https://www.instagram.com/adjarianfilmtales/">
                    <FontAwesomeIcon icon={faInstagram} />
                  </Link>
                </li>
                <LanguageSwitch className="navbar-lang-switch" />
              </div>
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
};

export default NavbarElem;
